module.exports = __webpack_public_path__ + "static/media/wallet-bag.731c6f76.svg";